// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"025daae7","211":"5b8d3ec7","283":"c2a43b7e","316":"2363210b","363":"8e481a8f","364":"55b6c7cb","410":"e199c7c8","412":"65c88e4b","570":"75053b45","607":"2e8f399f","713":"e1df1cd1","717":"75d8be98","911":"ce29c76f","991":"d15af122"}[chunkId] + ".chunk.js";
};